import { useFormContext, useWatch } from 'react-hook-form';
import useProvinceRequest from '@/common/hooks/useProvinceRequest.ts';
import useCountyRequest from '@/common/hooks/useCountyRequest.ts';
import ModalInput from '@/common/components/base/input/modalInput/ModalInput.tsx';

const ProvinceAndCounty = () => {
  const { control, setValue } = useFormContext();
  const { province } = useWatch({ control });
  const { provinceQuery, onProvinceSearchChange } = useProvinceRequest();
  const { countyQuery, onCountySearchChange } = useCountyRequest(
    province?.value,
  );
  const { data: countyOptions, isLoading: countyLoading } = countyQuery;
  const { data: provinceOptions, isLoading: provinceLoading } = provinceQuery;
  return (
    <>
      <ModalInput
        options={provinceOptions}
        rules={{ required: 'انتخاب کردن شهر اجباری میباشد' }}
        name="province"
        label="استان"
        placeholder="انتخاب استان"
        loading={provinceLoading}
        onChange={() => {
          setValue('county', null);
        }}
        searchOptions={{
          hasSearchAttachment: true,
          onChange: onProvinceSearchChange,
          placeholder: 'جستجو استان',
        }}
      />
      <ModalInput
        options={countyOptions}
        rules={{ required: 'انتخاب کردن شهر اجباری میباشد' }}
        name="county"
        label="شهر"
        placeholder="انتخاب شهر"
        loading={countyLoading}
        disabled={!province}
        searchOptions={{
          hasSearchAttachment: true,
          onChange: onCountySearchChange,
          placeholder: 'جستجو شهر',
        }}
      />
    </>
  );
};

export default ProvinceAndCounty;
